'use client'
import { AnimatePresence, domAnimation, LazyMotion, m as motion, useSpring } from 'framer-motion'

import { FC, useEffect, useState } from 'react'

import { IClassName } from '@/app/shared/interfaces/common.interface'

// interface
interface INumber extends IClassName {
  value: number
}

// component
const NumberComponent: FC<Readonly<INumber>> = ({ className, value }) => {
  const [displayValue, setDisplayValue] = useState(0)
  const currentValueSpring = useSpring(0, { stiffness: 30, damping: 40 })

  useEffect(() => {
    currentValueSpring.set(value)

    return currentValueSpring.on('change', (latestValue) => {
      setDisplayValue(Math.round(latestValue))
    })
  }, [value, currentValueSpring])

  // return
  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        <motion.span className={className}>{displayValue}</motion.span>
      </AnimatePresence>
    </LazyMotion>
  )
}

export default NumberComponent
